import { StyleSheet, Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

// Note: For dark mode support, these styles should not include color properties.
// Use Native Base's useColorModeValue hook or _dark props in components instead.
export const textStyle = StyleSheet.create({
    sectionText: {
        margin: 16,
        fontSize: 22,
        fontWeight: '700'
    },
    subSectionText: {
        marginTop: 16,
        fontSize: 16,  // Increased for consistency
        fontWeight: '600'
    },
    tableTitleText: {
        marginBottom: 12,
        marginTop: 20,
        fontSize: 18,  // Increased from 16/17
        fontWeight: '700'  // Increased for better hierarchy
    },
    measurementSectionText: {
        fontSize: 16,  // Increased for consistency
        fontWeight: '600'
    },
    statisticsTitle: {
        fontSize: 14,  // Increased from 12/13
        fontWeight: '500',  // Added for consistency
        textAlign: 'left'
    },
    inputLabel: {
        marginTop: 2,
        fontSize: 12,
    },
    title: {
        fontSize: 20,
        fontWeight: '700',
    },
    description: {
        fontSize: 15,
    }

})